"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueStandardFieldIds = void 0;
// for the purposes of reordering and hiding fields,
// we need identifiers for all the standard fields.
// IMPORTANT NOTE:
// These are only identifiers for the fields that are shown in the UI,
// and should not be confused with the attributes on the issue object.
// Although some identifiers may be the same, these identifiers
// should not be conflated with the attributes on an issue.
let IssueStandardFieldIds = exports.IssueStandardFieldIds = /*#__PURE__*/function (IssueStandardFieldIds) {
  IssueStandardFieldIds["Description"] = "description";
  IssueStandardFieldIds["Assignee"] = "assignedTo";
  IssueStandardFieldIds["Watchers"] = "watchers";
  IssueStandardFieldIds["Location"] = "locationId";
  IssueStandardFieldIds["LocationDetails"] = "locationDetails";
  IssueStandardFieldIds["GpsCoordinates"] = "gpsCoordinates";
  IssueStandardFieldIds["DueDate"] = "dueDate";
  IssueStandardFieldIds["StartDate"] = "startDate";
  IssueStandardFieldIds["Placement"] = "linkedDocuments";
  IssueStandardFieldIds["RootCauseWithCategory"] = "rootCauseId";
  IssueStandardFieldIds["Attachments"] = "attachments";
  IssueStandardFieldIds["References"] = "relationships";
  return IssueStandardFieldIds;
}({}); // type definitions: these describe the way the data in the payload should be
// this would be the custom attribute definition id
// IssueStandardFieldIds are named based on the fields that exist in the UI
//# sourceMappingURL=IssueType.js.map